import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useAuthState } from "../../../../../../../Helper/Context"
export const ReceivedComplaintsFromOfficials = (props) => {
    const { DataObj } = props

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token, UserFullName, RoleID } = userDetails

    const {

        PlanationDetailsCountdata,
        YearValue,
        MonthValue,
        ZoneValue,
        DashSelect,
        Language,

    } = DataObj

    const { t } = useTranslation()
    const navigate = useNavigate();

    const [ZoneHeaderData, setZoneHeaderData] = useState([])
    const [ZoneHeaderID, setZoneHeaderID] = useState(sessionStorage.getItem("ZoneHeaderID") ? sessionStorage.getItem("ZoneHeaderID") : '0')
    const [ZoneHeaderLable, seZoneHeaderLable] = useState(sessionStorage.getItem("ZoneHeaderLable") ? sessionStorage.getItem("ZoneHeaderLable") : '')

    const [Countdata, setCountdata] = useState({})

    const handleZoneDDL = (i) => {
        setZoneHeaderID(i.m_ZoneID);
        seZoneHeaderLable(i.zoneName)
        sessionStorage.setItem("ZoneHeaderID", i.m_ZoneID);
        sessionStorage.setItem("ZoneHeaderLable", i.zoneName);

    }

    useEffect(() => {
        const data = {
            UserID: UserID,
            Lanaguage: Language,
            Flag: 'UserWiseZone',
            token: token,
            HeaderFlag: 'HeaderFlag',
            setZoneHeaderData: setZoneHeaderData,
        }
    }, [Language])

    const { DDLData } = useSelector(state => state.ZoneNameDDLData)

    useEffect(() => {
        const data = {
            M_FinancialYearID: DataObj?.YearValue,
            M_MonthID: DataObj?.MonthValue,
            M_ZoneID: ZoneHeaderID,
            M_WorkTypeID: DataObj?.DashSelect,
            Flag: "WEB_Officials",
            M_UserID: UserID,
            token: token,
            handleGetCount: handleGetCount
        }

    }, [DataObj.YearValue, DataObj.MonthValue, DataObj.ZoneValue, ZoneHeaderID])


    const handleGetCount = (data) => {
        let tempData = {}
        data.forEach((item) => {
            tempData[item.paramName] = item.totalCount
        })
        setCountdata(tempData)
    }

    return (
        <div className="row m-1 mt-3 " >
            <div className="col-12 col-lg-12 bg-white rounded_eic" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }}>
                <div className="row">
                    <div className="col-12">
                        <div className="row my-1">
                            <div className="col-12 col-lg-4 pt-2 ps-3">
                                <span className="text-dark all_heading_fontsize">{t('EncroachmentDashboard.ComplaintStatusfromofficials')}</span>
                            </div>
                            <div className='col-12 col-md-12 col-lg-8 mx-auto pt-2 '>
                                <span className="card-headerbtnhor font-weight-bold py-3 ">
                                    <ul className="nav nav-tabs float-end me-lg-3 mb-md-2 mr-2 border">
                                        <div class="btn-group" role="group" aria-label="Basic mixed styles example">
                                            {
                                                RoleID == 6 || RoleID == 10 ?
                                                    <></>
                                                    :
                                                    <button
                                                        type="button"
                                                        className={ZoneHeaderID == "0" ? "active btn text-dark border-gray text-white" : "text-black  btn border-gray"}
                                                        onClick={() => setZoneHeaderID("0")}
                                                    >{t('EncroachmentDashboard.Total')}</button>
                                            }

                                            {
                                                ZoneHeaderData && ZoneHeaderData.table && ZoneHeaderData.table.length > 0 &&
                                                ZoneHeaderData.table.map((i) => {
                                                    return (
                                                        <button type="button"
                                                            className={ZoneHeaderID == i?.m_ZoneID ? "active btn text-dark border-gray text-white" : "text-black  btn border-gray"}
                                                            onClick={() => (handleZoneDDL(i))}
                                                        >{i.zoneName}

                                                        </button>
                                                    )
                                                })
                                            }

                                        </div>
                                    </ul>
                                </span>
                            </div>

                        </div>

                    </div>


                    {/* Received Complaint */}

                    <div className="col-12 col-md-12 col-lg-12 col-xl-6 pb-3"
                    >
                        <div className="px-4 pb-3 pt-3 rounded_eic background_style2  eic_PurpleColor" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
                            <div className="row">
                                <div className="col-12 d-flex justify-content-between pb-2">
                                    <span className=" text-dark fw-bold">{t('EncroachmentDashboard.ReceivedComplaint')}</span>
                                    <span className="fw-bold text-danger fs-3"> 0</span>
                                    <img src="./assets/img/eic_img/Received_Complaint.png" style={{ width: '40px' }} alt="" srcset="" />
                                </div>

                                <div className="col-12 col-md-4 col-lg-4 cursor-pointer" onClick={() => navigate(`/ReceivedComplaintGrid?Flag=SarthiPortal_ReceivedComplaint&DashSelect=${DashSelect}&ZoneID=${ZoneHeaderID == 0 ? 0 : ZoneHeaderID}&ZoneName=${ZoneHeaderLable == '' ? '' : ZoneHeaderLable}`)}>
                                    <div className="px-2 bg-white rounded_eic pt-3 text-center border border-3">
                                        <h6 className=" text-dark">{t('EncroachmentDashboard.SarthiPortal')}</h6>
                                        <h2 className="pt-2 fw-bold text-danger">{Countdata && Countdata.SarthiPortal_ReceivedComplaint ? Countdata.SarthiPortal_ReceivedComplaint.toFixed(0) : '0'}</h2>
                                    </div>
                                </div>
                                <div className="col-12 col-md-4 col-lg-4 cursor-pointer" onClick={() => navigate(`/ReceivedComplaintGrid?Flag=SocialMedia_ReceivedComplaint&DashSelect=${DashSelect}&ZoneID=${ZoneHeaderID == 0 ? 0 : ZoneHeaderID}&ZoneName=${ZoneHeaderLable == '' ? '' : ZoneHeaderLable}`)}>
                                    <div className="px-2 bg-white rounded_eic pt-3 text-center border border-3">
                                        <h6 className=" text-dark">{t('EncroachmentDashboard.SocialMedia')}</h6>
                                        <h2 className="pt-2 fw-bold text-danger">{Countdata && Countdata.SocialMedia_ReceivedComplaint ? Countdata.SocialMedia_ReceivedComplaint.toFixed(0) : '0'}</h2>
                                    </div>
                                </div>
                                <div className="col-12 col-md-4 col-lg-4 cursor-pointer" onClick={() => navigate(`/ReceivedComplaintGrid?Flag=OfficerVisit_ReceivedComplaint&DashSelect=${DashSelect}&ZoneID=${ZoneHeaderID == 0 ? 0 : ZoneHeaderID}&ZoneName=${ZoneHeaderLable == '' ? '' : ZoneHeaderLable}`)}>
                                    <div className="px-2 bg-white rounded_eic pt-3 text-center border border-3">
                                        <h6 className=" text-dark">{t('EncroachmentDashboard.OfficerVisit')}</h6>
                                        <h2 className="pt-2 fw-bold text-danger">{Countdata && Countdata.OfficerVisit_ReceivedComplaint ? Countdata.OfficerVisit_ReceivedComplaint.toFixed(0) : '0'}</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-12 col-lg-12 col-xl-6 pb-3 cursor-pointer"
                    >
                        <div className="px-4 pb-2 pt-3 rounded_eic background_style2  eic_Yellowcolor" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
                            <div className="row pt-lg-2">
                                {/* Acknowledged Complaint */}
                                <div className="col-12 col-md-6 pb-3 cursor-pointer"
                                    onClick={() => navigate(`/AcknowledgedComplaintGrid?DashSelect=${DashSelect}&ZoneID=${ZoneHeaderID == 0 ? 0 : ZoneHeaderID}&ZoneName=${ZoneHeaderLable == '' ? '' : ZoneHeaderLable}`)}
                                >
                                    <div className="p-4 rounded_eic eic_pinkcolor" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
                                        <div className="row">
                                            <div className="col-9 ps-0">
                                                <h6 className=" text-dark nowrap">{t('EncroachmentDashboard.AcknowledgedComplaint')}</h6>
                                                <h2 className="pt-2 fw-bold text-danger">{Countdata && Countdata.AcknowledgeComplaint ? Countdata.AcknowledgeComplaint.toFixed(0) : '0'}</h2>
                                            </div>
                                            <div className="col-3 d-flex align-items-center justify-content-center pt-3 ">
                                                <img src="./assets/img/eic_img/Acknowledged_Complaint.png" style={{ width: '40px' }} alt="" srcset="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Forward Complaint */}
                                <div className="col-12 col-md-6 pb-3 cursor-pointer"
                                    onClick={() => navigate(`/ForwardComplaintGrid?DashSelect=${DashSelect}&ZoneID=${ZoneHeaderID == 0 ? 0 : ZoneHeaderID}&ZoneName=${ZoneHeaderLable == '' ? '' : ZoneHeaderLable}`)}
                                >
                                    <div className="p-4 background_style rounded_eic eic_BlueColor" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
                                        <div className="row">
                                            <div className="col-9">
                                                <h6 className="text-dark nowrap">{t('EncroachmentDashboard.ForwardComplaint')}</h6>
                                                <h2 className="pt-2 fw-bold text-danger">{Countdata && Countdata.ForwardComplaint ? Countdata.ForwardComplaint.toFixed(0) : '0'}</h2>
                                            </div>
                                            <div className="col-3 d-flex align-items-center justify-content-center pt-3 ">
                                                <img src="./assets/img/eic_img/Forward_Complaint.png" style={{ width: '40px' }} alt="" srcset="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-12 pb-3 col-lg-12 col-xl-6 cursor-pointer"
                    >
                        <div className="px-4 pb-2 pt-3 rounded_eic background_style eic_Yellowcolor" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
                            <div className="row">
                                <div className="col-12 d-flex justify-content-between pb-2">
                                    <span className=" text-dark fw-bold">{t('EncroachmentDashboard.ClosedComplaint')}</span>
                                    <span className="fw-bold text-danger fs-3">0</span>
                                    <img src="./assets/img/eic_img/Closed_Complaint.png" style={{ width: '40px' }} alt="" srcset="" />
                                </div>
                                <div className="col-12 col-md-4 col-lg-4 cursor-pointer" onClick={() => navigate(`/ClosedComplaintGrid?Flag=SarthiPortal_CloseComplaint&DashSelect=${DashSelect}&ZoneID=${ZoneHeaderID == 0 ? 0 : ZoneHeaderID}&ZoneName=${ZoneHeaderLable == '' ? '' : ZoneHeaderLable}`)}>
                                    <div className="px-2 bg-white rounded_eic pt-3 text-center border border-3">
                                        <h6 className=" text-dark">{t('EncroachmentDashboard.SarthiPortal')}</h6>
                                        <h2 className="pt-2 fw-bold text-danger">{Countdata && Countdata.SarthiPortal_CloseComplaint ? Countdata.SarthiPortal_CloseComplaint.toFixed(0) : '0'}</h2>
                                    </div>
                                </div>
                                <div className="col-12 col-md-4 col-lg-4 cursor-pointer" onClick={() => navigate(`/ClosedComplaintGrid?Flag=SocialMedia_CloseComplaint&DashSelect=${DashSelect}&ZoneID=${ZoneHeaderID == 0 ? 0 : ZoneHeaderID}&ZoneName=${ZoneHeaderLable == '' ? '' : ZoneHeaderLable}`)}>
                                    <div className="px-2 bg-white rounded_eic pt-3 text-center border border-3">
                                        <h6 className=" text-dark">{t('EncroachmentDashboard.SocialMedia')}</h6>
                                        <h2 className="pt-2 fw-bold text-danger">{Countdata && Countdata.SocialMedia_CloseComplaint ? Countdata.SocialMedia_CloseComplaint.toFixed(0) : '0'}</h2>
                                    </div>
                                </div>
                                <div className="col-12 col-md-4 col-lg-4 cursor-pointer">
                                    <div className="px-2 bg-white rounded_eic pt-3 text-center border border-3" onClick={() => navigate(`/ClosedComplaintGrid?Flag=OfficerVisit_CloseComplaint&DashSelect=${DashSelect}&ZoneID=${ZoneHeaderID == 0 ? 0 : ZoneHeaderID}&ZoneName=${ZoneHeaderLable == '' ? '' : ZoneHeaderLable}`)}>
                                        <h6 className=" text-dark">{t('EncroachmentDashboard.OfficerVisit')}</h6>
                                        <h2 className="pt-2 fw-bold text-danger">{Countdata && Countdata.OfficerVisit_CloseComplaint ? Countdata.OfficerVisit_CloseComplaint.toFixed(0) : '0'}</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* Pending Complaint */}
                    <div className="col-12 col-md-12 pb-3 col-lg-12 col-xl-6"
                    >
                        <div className="px-4 pb-2 pt-3 rounded_eic background_style eic_PurpleColor" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
                            <div className="row">

                                <div className="col-12 d-flex justify-content-between pb-2">
                                    <span className=" text-dark fw-bold">{t('EncroachmentDashboard.PendingComplaint')}</span>
                                    <span className="fw-bold text-danger fs-3">0</span>
                                    <img src="./assets/img/eic_img/Pending_Complaint.png" style={{ width: '40px' }} alt="" srcset="" />
                                </div>
                                <div className="col-12 col-md-4 col-lg-4 cursor-pointer" onClick={() => navigate(`/OfficialsPendingComplaintGrid?Flag=SarthiPortal_PendingComplaint&DashSelect=${DashSelect}&ZoneID=${ZoneHeaderID == 0 ? 0 : ZoneHeaderID}&ZoneName=${ZoneHeaderLable == '' ? '' : ZoneHeaderLable}`)}>
                                    <div className="px-2 bg-white rounded_eic pt-3 text-center border border-3">
                                        <h6 className=" text-dark">{t('EncroachmentDashboard.SarthiPortal')}</h6>
                                        <h2 className="pt-2 fw-bold text-danger">{Countdata && Countdata.SarthiPortal_PendingComplaint ? Countdata.SarthiPortal_PendingComplaint.toFixed(0) : '0'}</h2>
                                    </div>
                                </div>
                                <div className="col-12 col-md-4 col-lg-4 cursor-pointer" onClick={() => navigate(`/OfficialsPendingComplaintGrid?Flag=SocialMedia_PendingComplaint&DashSelect=${DashSelect}&ZoneID=${ZoneHeaderID == 0 ? 0 : ZoneHeaderID}&ZoneName=${ZoneHeaderLable == '' ? '' : ZoneHeaderLable}`)}>
                                    <div className="px-2 bg-white rounded_eic pt-3 text-center border border-3">
                                        <h6 className=" text-dark">{t('EncroachmentDashboard.SocialMedia')}</h6>
                                        <h2 className="pt-2 fw-bold text-danger">{Countdata && Countdata.SocialMedia_PendingComplaint ? Countdata.SocialMedia_PendingComplaint.toFixed(0) : '0'}</h2>
                                    </div>
                                </div>
                                <div className="col-12 col-md-4 col-lg-4 cursor-pointer" onClick={() => navigate(`/OfficialsPendingComplaintGrid?Flag=OfficerVisit_PendingComplaint&DashSelect=${DashSelect}&ZoneID=${ZoneHeaderID == 0 ? 0 : ZoneHeaderID}&ZoneName=${ZoneHeaderLable == '' ? '' : ZoneHeaderLable}`)}>
                                    <div className="px-2 bg-white rounded_eic pt-3 text-center border border-3">
                                        <h6 className=" text-dark">{t('EncroachmentDashboard.OfficerVisit')}</h6>
                                        <h2 className="pt-2 fw-bold text-danger">{Countdata && Countdata.OfficerVisit_PendingComplaint ? Countdata.OfficerVisit_PendingComplaint.toFixed(0) : '0'}</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>


        </div>
    )
}